// deps
import React, { ReactElement, memo, useMemo, useContext } from "react";
import invariant from "tiny-invariant";

// internal deps
import { PaymentGroupDataDef, MorePaymentMethodsLoadingScreen } from "@swiggy-private/payment-ui";

// components
import CommonHeaderContent from "@payment-client/components/common-header-content/CommonHeaderContent";
import CommonUIWrapper from "@payment-client/components/common-ui-wrapper/CommonUIWrapper";
import { MorePaymentMethodsContent } from "./components/MorePaymentMethodsContent";

// interfaces
import { RouteProps } from "@payment-client/interfaces/Router";

// constants
import { MISSING_ROUTE_DATA } from "@payment-client/constants/Route";

// hooks

// contexts
import { ShowPaymentContext } from "@payment-client/contexts/ShowPaymentContext";

// helpers
import { getMoreMethodsPageTitle } from "@payment-client/helpers/MorePayments";

type MorePaymentMethodsRouteProps = RouteProps<{ paymentGroup: PaymentGroupDataDef }>;

export const MorePaymentMethods = memo(function MorePaymentMethods({
    data,
}: MorePaymentMethodsRouteProps): ReactElement | null {
    const { loadingPayments } = useContext(ShowPaymentContext);

    invariant(data?.paymentGroup, MISSING_ROUTE_DATA);

    const title = useMemo(() => getMoreMethodsPageTitle(data.paymentGroup), [data.paymentGroup]);

    const header = <CommonHeaderContent title={title} grayscale />;

    const content = useMemo(() => {
        if (loadingPayments) {
            return <MorePaymentMethodsLoadingScreen />;
        }
        return <MorePaymentMethodsContent paymentGroupName={data?.paymentGroup.groupName} />;
    }, [loadingPayments, data]);

    return <CommonUIWrapper header={header} content={content} />;
});
